import React, { useEffect, useState } from 'react';
import { playaudio, getaudio } from '../../common/functions';
import './controls.css';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
export function Controls(props) {
    var _a = useState(''), answer = _a[0], setAnswer = _a[1];
    var _b = useState(false), screen = _b[0], isScreen = _b[1];
    function changecolor(element) {
        if (element !== answer)
            return 'aftergame';
        else if (answer === props.items[props.counter].wordTranslate)
            return 'win';
        else
            return 'lose';
    }
    useEffect(function () {
        document.body.click();
        playaudio(getaudio(props.items[props.counter].audio));
    }, [props.counter, props.items, props.load]);
    useEffect(function () {
        function handlekeydown(evt) {
            if (!screen) {
                for (var i = 1; i < 6; i += 1) {
                    if (evt.code === "Digit".concat(i)) {
                        setAnswer(props.items[props.counter].variant[i - 1]);
                        isScreen(true);
                        props.updatefunc(props.items[props.counter].variant[i - 1]);
                    }
                }
            }
            else {
                if (evt.code === 'Space') {
                    isScreen(false);
                    props.updatecount();
                }
            }
        }
        document.addEventListener('keydown', handlekeydown);
        return function () { return document.removeEventListener('keydown', handlekeydown); };
    });
    if (!screen)
        return (React.createElement("div", null,
            React.createElement("div", { className: "audio" },
                React.createElement("button", { onClick: function () {
                        return playaudio(getaudio(props.items[props.counter].audio));
                    } },
                    React.createElement(VolumeUpIcon, { sx: { fontSize: 90 } }))),
            React.createElement("div", { className: "variants" }, props.items[props.counter].variant.map(function (element, index) {
                return (React.createElement("button", { key: props.items[props.counter].id + "".concat(element), onClick: function () {
                        setAnswer(element);
                        isScreen(true);
                        props.updatefunc(element);
                    } },
                    index + 1,
                    " ",
                    element));
            })),
            React.createElement("div", { className: "nextcontainer" },
                React.createElement("button", { className: "next   red", onClick: function () {
                        setAnswer('wqrqwerqwer');
                        isScreen(true);
                        props.updatefunc('qwerqwerqwer');
                    } }, "\u042F \u043D\u0435 \u0437\u043D\u0430\u044E"))));
    else
        return (React.createElement("div", null,
            React.createElement("div", { className: "image" },
                React.createElement("img", { src: "https://qwerzxvxzvzxvxzv.herokuapp.com/".concat(props.items[props.counter].image), alt: "" })),
            React.createElement("div", { className: "postaudio" },
                React.createElement("button", { onClick: function () {
                        return playaudio(getaudio(props.items[props.counter].audio));
                    } },
                    React.createElement(VolumeUpIcon, { sx: { fontSize: 30 } }))),
            React.createElement("div", { className: "variants" }, props.items[props.counter].variant.map(function (element, index) {
                return (React.createElement("button", { className: changecolor(element), key: props.items[props.counter].id + "".concat(element) },
                    index + 1,
                    " ",
                    element));
            })),
            React.createElement("div", { className: "nextcontainer" },
                React.createElement("button", { className: "next green", onClick: function () {
                        isScreen(false);
                        props.updatecount();
                    } },
                    React.createElement(ArrowRightAltIcon, null)))));
}
